module.exports = __webpack_public_path__ + "img/4eventfacilities.eb5edd01.png";